import { api, ApiRequest } from '../instance';

export const deleteRaw = api.delete;

export async function deleteRequest<T = any>(url: string, config: ApiRequest = {}): Promise<T> {
  return (await deleteRaw<T>(url, config)).data;
}
